<template>
  <div style="width: auto">
    <template-list
      :auto-load-list="false"
      :model="$terminal"
      :show-create-button="false"
      hide-items
    >
      <template v-slot:actions>
        <v-autocomplete
          v-model="$terminal.filters.outlet"
          :items="$outlet.list"
          :item-text="v => v.number + '. ' + v.address"
          class="rounded-lg mr-3"
          clearable
          dense
          hide-details
          item-value="id"
          label="Торговая точка"
          outlined
          style="max-width: 300px"
          @change="loadList"
        />
        <v-btn
          :loading="$terminal.loadings.list"
          class="rounded-lg text-none body-2"
          color="primary"
          depressed
          height="40"
          @click="loadList"
        >
          Обновить
        </v-btn>
      </template>
      <template v-slot:items>
        <v-data-table
          :headers="headers"
          :items="sortedTerminals"
          :items-per-page="-1"
          hide-default-footer
          no-data-text="Нет киосков"
        >
          <template v-slot:item.outlet="{ item }">
            {{ item.outlet ? item.outlet.address : '—' }}
          </template>

          <template v-slot:item.appVersion="{ item }">
            <div style="min-width: 80px">
              {{ item.app_version ? item.app_version : '—' }}
            </div>
          </template>

          <template v-slot:item.name="{ item }">
            <v-text-field
              v-model="item.name"
              class="rounded-lg"
              dense
              hide-details
              outlined
              style="min-width: 140px"
            />
          </template>

          <template v-slot:item.online="{ item }">
            <v-chip
              :color="isOnline(item) ? 'success' : 'error'"
              outlined
              small
            >
              {{ isOnline(item) ? 'Онлайн' : 'Офлайн' }}
            </v-chip>
          </template>

          <template v-slot:item.last_online_at="{ item }">
            <template v-if="getLastOnlineAt(item)">
              <div class="body-2">{{ getLastOnlineAt(item).date }}</div>
              <div class="body-2">{{ getLastOnlineAt(item).time }}</div>
            </template>
            <span
              v-else
              class="body-2"
              >—</span
            >
          </template>

          <template v-slot:item.local_terminal_ip="{ item }">
            <v-text-field
              v-model="item.local_terminal_ip"
              class="rounded-lg"
              dense
              hide-details
              outlined
              style="min-width: 130px"
            />
          </template>

          <template v-slot:item.local_terminal_port="{ item }">
            <v-text-field
              v-model="item.local_terminal_port"
              class="rounded-lg"
              dense
              hide-details
              outlined
              type="number"
              style="min-width: 90px"
            />
          </template>

          <template v-slot:item.local_terminal_number="{ item }">
            <v-text-field
              v-model="item.local_terminal_number"
              class="rounded-lg"
              dense
              hide-details
              outlined
              style="min-width: 140px"
            />
          </template>

          <template v-slot:item.actions="{ item, index }">
            <v-row
              no-gutters
              style="gap: 6px; flex-wrap: nowrap"
            >
              <v-btn
                :color="item.active ? 'warning' : 'success'"
                :loading="loadingIds.includes(item.uuid)"
                class="rounded-lg text-none"
                depressed
                height="32"
                small
                @click="toggleActive(item, index)"
              >
                {{ item.active ? 'Остановить' : 'Запустить' }}
              </v-btn>
              <v-btn
                :loading="savingIds.includes(item.uuid)"
                class="rounded-lg text-none"
                color="primary"
                depressed
                height="32"
                small
                @click="saveTerminal(item, index)"
              >
                Сохранить
              </v-btn>
              <v-btn
                :loading="deletingIds.includes(item.uuid)"
                class="rounded-lg text-none"
                color="error"
                depressed
                height="32"
                outlined
                small
                @click="deleteTerminal(item, index)"
              >
                Удалить
              </v-btn>
            </v-row>
          </template>
        </v-data-table>
      </template>
    </template-list>

    <v-dialog
      v-model="confirmDialog"
      max-width="400"
    >
      <v-card
        v-if="pendingDelete"
        class="pa-5 rounded-lg"
      >
        <div class="font-weight-bold mb-3">Удаление киоска</div>
        <div class="body-2">
          Вы уверены, что хотите удалить киоск <strong>{{ pendingDelete.item.name }}</strong
          >?
        </div>
        <v-row
          class="px-2 mt-4"
          no-gutters
        >
          <v-btn
            :loading="deletingIds.includes(pendingDelete.item.uuid)"
            class="rounded-lg text-none"
            color="error"
            depressed
            @click="confirmDelete"
          >
            Удалить
          </v-btn>
          <v-spacer />
          <v-btn
            class="rounded-lg text-none"
            outlined
            @click="confirmDialog = false"
          >
            Отмена
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'TerminalList',
    data: () => ({
      headers: [
        { text: 'Торговая точка', value: 'outlet', sortable: false },
        { text: 'Версия ПО', value: 'appVersion', sortable: false },
        { text: 'Название', value: 'name', sortable: false },
        { text: 'Онлайн', value: 'online', sortable: false },
        { text: 'Был в сети', value: 'last_online_at', sortable: false, width: '140px' },
        { text: 'IP', value: 'local_terminal_ip', sortable: false },
        { text: 'Порт', value: 'local_terminal_port', sortable: false },
        { text: 'ID терминала', value: 'local_terminal_number', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ],
      displayDeviceMap: {},
      loadingIds: [],
      savingIds: [],
      deletingIds: [],
      confirmDialog: false,
      pendingDelete: null
    }),
    methods: {
      loadList() {
        this.$terminal.loadList().then(() => {
          this.loadDisplayDevices()
        })
      },
      loadDisplayDevices() {
        const uuids = this.$terminal.list.map(t => t.uuid)
        if (!uuids.length) return
        this.$displayDevice.sendGet('', { page_size: 'all' }).then(data => {
          const results = data.results || data
          const map = {}
          results.forEach(d => {
            map[d.uuid] = d
          })
          this.displayDeviceMap = map
        })
      },
      parseUtcDate(str) {
        return new Date(str.replace(' ', 'T') + 'Z')
      },
      isOnline(terminal) {
        const device = this.displayDeviceMap[terminal.uuid]
        if (!device || !device.last_online_at) return false
        const diff = (Date.now() - this.parseUtcDate(device.last_online_at).getTime()) / 1000 / 60
        return diff < 3
      },
      getLastOnlineAt(terminal) {
        const device = this.displayDeviceMap[terminal.uuid]
        if (!device || !device.last_online_at) return null
        const d = this.parseUtcDate(device.last_online_at)
        return {
          date: d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: 'numeric' }),
          time: d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
        }
      },
      toggleActive(item, index) {
        this.loadingIds.push(item.uuid)
        axios
          .patch(`/terminals/${item.uuid}/`, { active: !item.active })
          .then(({ data }) => {
            this.$set(this.$terminal.list, index, data)
          })
          .finally(() => {
            this.loadingIds = this.loadingIds.filter(id => id !== item.uuid)
          })
      },
      saveTerminal(item, index) {
        this.savingIds.push(item.uuid)
        this.$terminal
          .update(item)
          .then(v => {
            this.$set(this.$terminal.list, index, v)
          })
          .finally(() => {
            this.savingIds = this.savingIds.filter(id => id !== item.uuid)
          })
      },
      deleteTerminal(item, index) {
        this.pendingDelete = { item, index }
        this.confirmDialog = true
      },
      confirmDelete() {
        const { item, index } = this.pendingDelete
        this.deletingIds.push(item.uuid)
        this.$terminal
          .delete(item.uuid)
          .then(() => {
            this.$terminal.list.splice(index, 1)
            this.confirmDialog = false
          })
          .finally(() => {
            this.deletingIds = this.deletingIds.filter(id => id !== item.uuid)
          })
      }
    },
    created() {
      this.loadList()
      this.$outlet.loadList()
    },
    computed: {
      sortedTerminals() {
        return [...this.$terminal.list].sort((a, b) => {
          const aNum = a.outlet?.number ?? 0
          const bNum = b.outlet?.number ?? 0
          return aNum - bNum
        })
      }
    },
    watch: {
      confirmDialog(val) {
        if (!val) this.pendingDelete = null
      }
    }
  }
</script>
